import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Footer from "../components/Footer";
import ComponentSearch from "../components/Search";
import ComponentHomeContent from "../components/HomeContent";
import AnimationFrame from "../lib/AnimationFrame";
import * as index from "../actions/index";
import * as global from "../actions/global";

class HOME extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentComponentSearch: null,
      currentComponentHomeContent: null,
      configData: {}
    };
    this.animationControl = new AnimationFrame();
  }
  
  componentDidMount() {
    // console.log("测试页面是否只走了一遍");
    const {_homeConfig, _homeConfig2} = this.props;
    if(_homeConfig2 && _homeConfig2.results && _homeConfig2.results.specialMomentDto && _homeConfig2.results.specialMomentDto.homePageShouldGray == true){
      // 针对首页进行置灰
      let bodyStyle = document.querySelector("html").style;
      bodyStyle.cssText = `
        -webkit-filter: grayscale(100%); /* webkit */ 
        -moz-filter: grayscale(100%); /*firefox*/ 
        -ms-filter: grayscale(100%); /*ie9*/ 
        -o-filter: grayscale(100%); /*opera*/ 
        filter: grayscale(100%); 
        filter:progid:DXImageTransform.Microsoft.BasicImage(grayscale=1); 
        filter:gray; /*ie9- */
      `
  }
  }

  render() {
    let site = [],M_Footer = <Footer key={"footer"} />;
    let currentComponentSearch=  <ComponentSearch key="ComponentSearch" pcHomePage="pcHomePage"/>
    let currentComponentHomeContent = <ComponentHomeContent key="ComponentHomeContent" configData={this.props._homeConfig.results}  pcHomePage="ComponentHomeContent"/>;
    site.push(currentComponentSearch);
    site.push(currentComponentHomeContent);
    site.push(M_Footer);
    return <div className="site">{site}</div>;
  }
}

export default connect(
  (state) => ({
    _homeConfig: state.homeConfig,
    _homeConfig2: state.homeConfig2,
  }),
  (dispatch) => ({
    index: bindActionCreators(index, dispatch),
    global: bindActionCreators(global, dispatch),
    dispatch,
  })
)(HOME);



// WEBPACK FOOTER //
// ./common/containers/Home.js